/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { toggleDocumentUnreadPostRequestSchema } from './toggleDocumentUnreadPostRequestSchema.ts';
import { toggleDocumentUnreadPostResponseSchema } from './toggleDocumentUnreadPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postToggleDocumentUnread200Schema = z.lazy(() => toggleDocumentUnreadPostResponseSchema);

/**
 * @description 505 response
 */
export const postToggleDocumentUnread505Schema = z.any();

export const postToggleDocumentUnreadMutationRequestSchema = z.lazy(() => toggleDocumentUnreadPostRequestSchema);

export const postToggleDocumentUnreadMutationResponseSchema = z.lazy(() => postToggleDocumentUnread200Schema);
